import {registerMaterialGraphNode} from "#material/register"
import {threeValue} from "#material/three/three-utils"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {LightPathSockets} from "#material/nodes/input/light-path/definition"
import {lightPathDefinition} from "#material/nodes/input/light-path/definition"
import type {LightPathNode} from "#material/cycles/types"
import type {ThreeReturns} from "#material/sockets/three"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import type {CyclesReturns} from "#material/sockets/cycles"

@registerMaterialGraphNode
export class LightPath extends MaterialNode<LightPathSockets> {
    public override get definition() {
        return lightPathDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<LightPathSockets>> => {
        return {
            diffuseDepth: threeValue(this.parameters.settings.diffuseDepth ?? 0),
            glossyDepth: threeValue(this.parameters.settings.glossyDepth ?? 0),
            isCameraRay: threeValue(this.parameters.settings.isCameraRay ?? 0),
            isDiffuseRay: threeValue(this.parameters.settings.isDiffuseRay ?? 0),
            isGlossyRay: threeValue(this.parameters.settings.isGlossyRay ?? 0),
            isReflectionRay: threeValue(this.parameters.settings.isReflectionRay ?? 0),
            isShadowRay: threeValue(this.parameters.settings.isShadowRay ?? 0),
            isSingularRay: threeValue(this.parameters.settings.isSingularRay ?? 0),
            isTransmissionRay: threeValue(this.parameters.settings.isTransmissionRay ?? 0),
            rayDepth: threeValue(this.parameters.settings.rayDepth ?? 0),
            rayLength: threeValue(this.parameters.settings.rayLength ?? 0),
            transmissionDepth: threeValue(this.parameters.settings.transmissionDepth ?? 0),
            transparentDepth: threeValue(this.parameters.settings.transparentDepth ?? 0),
        }
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<LightPathSockets>> => {
        const lightPath: LightPathNode = {
            type: "light_path",
            inputs: {},
            parameters: {},
            resources: {},
        }

        return {
            diffuseDepth: [lightPath, "diffuse_depth"],
            glossyDepth: [lightPath, "glossy_depth"],
            isCameraRay: [lightPath, "is_camera_ray"],
            isDiffuseRay: [lightPath, "is_diffuse_ray"],
            isGlossyRay: [lightPath, "is_glossy_ray"],
            isReflectionRay: [lightPath, "is_reflection_ray"],
            isShadowRay: [lightPath, "is_shadow_ray"],
            isSingularRay: [lightPath, "is_singular_ray"],
            isTransmissionRay: [lightPath, "is_transmission_ray"],
            rayDepth: [lightPath, "ray_depth"],
            rayLength: [lightPath, "ray_length"],
            transmissionDepth: [lightPath, "transmission_depth"],
            transparentDepth: [lightPath, "transparent_depth"],
        }
    }
}
